import request from './services/axios.js'

export default {
  addPaperManager: (params) => {
    return request({
      params,
      url: '/ebook/baozhi/addBaoZhi'
    })
  },
  getPaperManagerList: (params) => {
    return request({
      params,
      url: '/ebook/baozhi/getBaoZhiByPage',
      method: 'get'
    })
  },
  getPaperArticleList: (params) => {
    return request({
      params,
      url: '/ebook/epaperXY/findEpaperXiaoYangPage',
      method: 'get'
    })
  },
  deletePaperManager: (params) => {
    return request({
      params,
      url: '/ebook/baozhi/delBaoZhi',
      method: 'get'
    })
  },
  /*报纸通过微信分享时调用的接口，报纸分享内容是报纸最新期刊的内容。*/
  wxShareParams: (params) => {
    return request({
      params,
      url: 'ebook/baozhi/wxShareParams',
      method: 'get'
    })
  },
  modifyPaperManager: (params) => {
    return request({
      params,
      url: '/ebook/baozhi/modifyBaoZhiName',
      method: 'get'
    })
  },
  getDefaultSetting: (id) => {
    return request({
      url: 'ebook/baozhi/getDefaultSetting?baozhiId=' + id,
      method: 'get'
    })
  },
  setPaperDefaultSetting: (params) => {
    return request({
      data: params,
      url: '/ebook/baozhi/editDefaultSetting?baozhiId=' + params.baozhiId,
      method: 'post',
      contenType: 'application/json'
    })
  },
  //批量修改背景
  setPaperDefaultBg: (params) => {
    return request({
      data: params,
      url: '/ebook/baozhi/batchModifyBg?baozhiId=' + params.baozhiId,
      method: 'post',
      contenType: 'application/json'
    })
  },
  //批量修改个性设置
  setPaperDefaultPersonal: (params) => {
    return request({
      data: params,
      url: '/ebook/baozhi/batchModifySetting?baozhiId=' + params.baozhiId,
      method: 'post',
      contenType: 'application/json'
    })
  },
  getGroupShareSetting: (userName, grouping) => {
    return request({
      url: '/ebook/epaperGroup/getSetting?userName=' + userName + '&grouping=' + grouping,
      method: 'get'
    })
  },
  setGroupShareSetting: (params) => {
    return request({
      data: params,
      url: '/ebook/epaperGroup/editSetting',
      method: 'post'
    })
  },
  setShareContent: (params) => {
    return request({
      params,
      url: 'ebook/epaperGroup/setShareContent',
      method: 'get'
    })
  },
  getShareContent: (params) => {
    return request({
      params,
      url: '/ebook/epaperGroup/getShareContent',
      method: 'get'
    })
  },
  setSwitchGroup: (params) => {
    return request({
      params,
      url: '/ebook/epaperGroup/setSwitchGroup',
      method: 'get'
    })
  },
  shareDisplay: (params) => {
    return request({
      params,
      url: '/ebook/epaperGroup/shareDisplay',
      method: 'get'
    })
  },
  wxGroupShareParams: (params) => {
    return request({
      params,
      url: '/ebook/epaperGroup/wxShareParams',
      method: 'get'
    })
  },
  batchAddMigrateFile: (params) => {
    return request({
      url: '/ebook/epaper/batchAddMigrateFile?migrateFileAccountArr=' + params,
      method: 'post'
    })
  },
  getUserMigrateAuthList: (params) => {
    return request({
      params,
      url: '/ebook/epaper/getUserMigrateAuthList',
      method: 'get'
    })
  },
  getMigrateFileAccountByQuery: (params) => {
    return request({
      params,
      url: '/ebook/epaper/getMigrateFileAccountByQuery',
      method: 'get'
    })
  },
  getMigrateAuth: (params) => {
    return request({
      params,
      url: '/ebook/epaper/getMigrateAuth',
      method: 'get'
    })
  },
  addTopic: (params) => {
    return request({
      params,
      url: '/ebook/epaper/addTopic',
      method: 'post'
    })
  },
  delTopic: (params) => {
    return request({
      params,
      url: '/ebook/epaper/delTopic',
      method: 'get'
    })
  },
  getTopicByPage: (params) => {
    return request({
      params,
      url: '/ebook/epaper/getTopicByPage',
      method: 'get'
    })
  },
  getTopicById: (params) => {
    return request({
      params,
      url: '/ebook/epaper/getTopicById',
      method: 'get'
    })
  },
  editTopic: (params) => {
    return request({
      data: params,
      url: '/ebook/epaper/editTopic',
      method: 'post'
    })
  },
  getArticlePageByTopicId: (params) => {
    return request({
      params,
      url: '/ebook/epaper/getArticlePageByTopicId',
      method: 'get'
    })
  },
  /*报纸通过微信分享时调用的接口，报纸分享内容是报纸最新期刊的内容。*/
  topicWxShareParams: (params) => {
    return request({
      params,
      url: 'ebook/epaper/topicWxShareParams',
      method: 'get'
    })
  },
  // 批量撤版-撤版接口
  revoke: (params) => {
    return request({
      params,
      url: '/ebook/revokeLayout/startRevoke',
      method: 'post'
    })
  },
  // 批量撤版-撤版记录分页查询
  getEpaperRevokeLayoutByPage: (params) => {
    return request({
      params,
      url: '/ebook/revokeLayout/getEpaperRevokeLayoutByPage',
      method: 'get'
    })
  }
}
